/**
 * New Customer Page
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { AppShell } from '../components/layout/AppShell';
import { CustomerForm } from '../components/customers/CustomerForm';
import { useCreateCustomer } from '../hooks/useCustomers';
import { useToastHelpers } from '../components/ui/Toast';
import { PageHeader } from '../components/ui';
import { markFormSaved } from '../hooks/useUnsavedChanges';

export const Route = createFileRoute('/customers_/new')({
  component: NewCustomerPage,
});

function NewCustomerPage() {
  const navigate = useNavigate();
  const toast = useToastHelpers();
  const createCustomer = useCreateCustomer();

  const handleSubmit = async (data: Parameters<typeof createCustomer.mutate>[0]) => {
    try {
      const customer = await createCustomer.mutateAsync(data);
      markFormSaved();
      toast.success('Kunde erstellt');
      navigate({ to: '/customers/$id', params: { id: customer.id } });
    } catch {
      toast.error('Fehler beim Erstellen');
    }
  };

  return (
    <ProtectedRoute>
      <AppShell>
        <PageHeader backTo="/customers" backLabel="Kunden" title="Neuer Kunde" />

        <CustomerForm
          onSubmit={handleSubmit}
          isLoading={createCustomer.isPending}
          onCancel={() => navigate({ to: '/customers' })}
        />
      </AppShell>
    </ProtectedRoute>
  );
}
